// extracted by mini-css-extract-plugin
export default {"rounded_image":"RoundedImage_rounded_image__oYj7C","px75":"RoundedImage_px75__NMv6E"};